export default __webpack_public_path__ + "static/NeffSans-Regular-7e0ded90f817b1221cf340fb5d6bf7f2.woff";